import type { RawHeroStats, HeroStats } from '../../props/types/HeroStats'

export default function heroStatsParser(
  heroStats?: RawHeroStats,
): { heroStats?: HeroStats } {
  if (heroStats) {
    const { age, ...restHeroStats } = heroStats

    return {
      heroStats: {
        age: Number(age),
        ...restHeroStats,
      },
    }
  } else {
    return {}
  }
}
